import type { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { ContentText } from 'pdfmake/interfaces';

import { useLazyGetFormConfigurationByParentType } from '@/hooks/queries';
import type { JSONObject } from '@/types/types';

import { getCustomAttributeDataForExport } from './getCustomAttributeDataForExport';

const useCustomAttributeDataForExport = <
  T extends {
    CustomAttributeData?: JSONObject | null;
  },
>(
  parentType: Parent_Type_Enum
): [(item: T) => Promise<(ContentText | string)[]>, boolean] => {
  const [getSchema, getSchemasResult] =
    useLazyGetFormConfigurationByParentType();

  return [
    async (item: T) => {
      const { data: schemaData } = await getSchema({
        parentTypes: [parentType],
      });

      return getCustomAttributeDataForExport(
        item,
        schemaData?.form_configuration?.[0]?.customAttributeSchema
      );
    },
    getSchemasResult.loading,
  ];
};
export default useCustomAttributeDataForExport;
